/**
 * Returns initials from a name:
 * - Two+ words: first letter of first and last word (e.g., "Super Admin" → "SA")
 * - Single word: first two letters (e.g., "Super" → "SU")
 * - Empty/undefined: "?"
 */
export function getInitials(name) {
    if (!name || !name.trim()) return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return parts[0].slice(0, 2).toUpperCase();
}